import { normalizeLocale, type SupportedLocale } from './config';
import { imageRequestSizeCopy } from './image-request-size-copy';

const COPY: Record<SupportedLocale, string> = {
  en: 'The image service could not use an extra reference image. Replace or remove the extra reference and try again.',
  ar: 'تعذّر على خدمة الصور استخدام إحدى الصور المرجعية الإضافية. استبدل الصورة المرجعية الإضافية أو أزلها ثم حاول مرة أخرى.',
  es: 'El servicio de imágenes no pudo usar una imagen de referencia adicional. Sustituye o elimina la referencia adicional e inténtalo de nuevo.',
  'pt-BR':
    'O serviço de imagens não conseguiu usar uma imagem de referência adicional. Substitua ou remova a referência adicional e tente novamente.',
  fr: 'Le service d’images n’a pas pu utiliser une image de référence supplémentaire. Remplacez ou supprimez cette référence et réessayez.',
  it: 'Il servizio immagini non ha potuto usare un’immagine di riferimento aggiuntiva. Sostituisci o rimuovi il riferimento aggiuntivo e riprova.',
  ko: '이미지 서비스에서 추가 참조 이미지를 사용할 수 없었습니다. 추가 참조 이미지를 바꾸거나 삭제한 후 다시 시도해 주세요.',
  de: 'Der Bilddienst konnte ein zusätzliches Referenzbild nicht verwenden. Ersetze oder entferne das zusätzliche Referenzbild und versuche es erneut.',
  ja: '画像サービスで追加の参照画像を使用できませんでした。追加の参照画像を差し替えるか削除して、もう一度お試しください。',
  hi: 'इमेज सेवा एक अतिरिक्त संदर्भ इमेज का उपयोग नहीं कर सकी। अतिरिक्त संदर्भ इमेज को बदलें या हटाएँ और फिर कोशिश करें।',
  ru: 'Сервис изображений не смог использовать дополнительное референсное изображение. Замените или удалите его и повторите попытку.',
  zh: '图像服务无法使用额外的参考图像。请替换或移除额外的参考图像，然后重试。',
  'zh-TW':
    '影像服務無法使用額外的參考影像。請替換或移除額外的參考影像，然後重試。',
  vi: 'Dịch vụ hình ảnh không thể sử dụng ảnh tham chiếu bổ sung. Hãy thay thế hoặc xóa ảnh tham chiếu bổ sung rồi thử lại.',
  id: 'Layanan gambar tidak dapat menggunakan gambar referensi tambahan. Ganti atau hapus referensi tambahan, lalu coba lagi.',
};

/** Only our typed outcome gets this copy; arbitrary provider text stays hidden. */
export function imageReferenceRejectionCopy(
  error: string | null | undefined,
  locale: string | null | undefined
): string | undefined {
  if (error?.includes('IMAGE_REQUEST_TOO_LARGE:'))
    return imageRequestSizeCopy(locale);
  return error?.includes('IMAGE_PROVIDER_REFERENCE_REJECTED:')
    ? COPY[normalizeLocale(locale)]
    : undefined;
}
